import React from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_racing-simulator-hub/artifacts/e53tel1d_ChatGPT%20Image%2015%20de%20jul.%20de%202026%2C%2010_03_10.png";

export default function Logo({ size = 40, showWordmark = true, className = "", wordmarkClass = "" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <div
        className="relative rounded-full overflow-hidden bg-black flex-shrink-0"
        style={{ width: size, height: size, boxShadow: "0 0 18px rgba(227,27,35,0.25), 0 0 24px rgba(0,140,255,0.18)" }}
      >
        <img
          src={LOGO_URL}
          alt="SIM EXPERIENCE"
          className="w-full h-full object-cover"
          loading="eager"
        />
      </div>
      {showWordmark && (
        <div className={`font-display font-black tracking-tight leading-none ${wordmarkClass || "text-lg"}`}>
          <span className="text-white">SIM</span>
          <span className="text-[#E31B23]">.</span>
          <span className="text-white">EXPERIENCE</span>
        </div>
      )}
    </div>
  );
}
